import React from 'react'
import { Box, Paper, TagsInput, Text } from '@mantine/core'
import { useUserGeneralFormContext } from '../hook/user-general-form'

const UserMarkingCode = () => {
  const form = useUserGeneralFormContext()

  return (
    <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
      <Text fw={500}>
        User Marking Code
      </Text>
      <Box my={12}>
        <TagsInput
          label='Marking Code'
          description='Press Enter to add Marking Code'
          size='xs'
          placeholder='Enter Marking Code'
          key={form.key('marking_codes')}
          {...form.getInputProps('marking_codes')}
        />
      </Box>
    </Paper>
  )
}

export default UserMarkingCode